import { avantSolarApi } from "api/authApi";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { log } from "util";

const formatosPermitidos = [".xls", ".xlsx", ".xlsm", ".xlsb", ".csv"];

const ModifyFileModal = ({
  modal,
  toggleModal,
  fechaInput,
  fetchLecturas,
  idUser,
  children,
}) => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [errorExtension, setErrorExtension] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [datos, setDatos] = useState();
  const [file, setFile] = useState(null);

  const cerrarModal = () => {
    toggleModal();
    setError(null);
    setErrorExtension(false);
    setButtonDisabled(true);
    setSuccess(false);
  };

  const closeBtn = (
    <button className="close" onClick={cerrarModal} type="button">
      &times;
    </button>
  );

  useEffect(() => {
    window.addEventListener("click", () => {
      setErrorExtension(false);
      setButtonDisabled(true);
    });
  }, []);

  const comprobarArchivo = (event) => {
    const archivoSeleccionado = event.target.files[0]; // Obtener el archivo seleccionado
    setErrorExtension(false);
    if (archivoSeleccionado) {
      const nombreArchivo = archivoSeleccionado.name;
      const extension = nombreArchivo.split(".").pop().toLowerCase();
      console.log("Extensión del archivo:", extension);

      if (!formatosPermitidos.includes("." + extension)) {
        // Si la extensión no está en el array de formatos permitidos, mostrar un mensaje de error o tomar medidas adecuadas.
        event.target.value = null;
        setButtonDisabled(true);
        setErrorExtension(true);
        setFile(null);
        return;
      }
      console.log(event.target.files);
      setFile(event.target.files[0]);
      // Aquí puedes realizar acciones adicionales con el archivo si tiene el formato permitido.
      setButtonDisabled(false);
    }
  };

  const modificarLecturas = async (ev) => {
    setError(null);

    const formData = new FormData();
    formData.append("excel", file);
    formData.append("id_huerta", huerta);
    formData.append("fecha", fechaInput);

    try {
      const response = await avantSolarApi.post(
        "/admins/updateMeter  ",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      console.log(data);
      if (data?.code == 200) {
        setSuccess(true);
        fetchLecturas(fechaInput);
        console.log(fechaInput);
      } else {
        setSuccess(false);
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
      setSuccess(false);
    }
  };

  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader close={closeBtn} toggle={toggleModal}>
          Modificar lecturas
        </ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column file-select">
            <input
              onChange={(ev) => comprobarArchivo(ev)}
              type="file"
              accept=".xls,.xlsx,.xlsm,.xlsb,.csv"
            />
            {errorExtension && (
              <small className="error-text mt-2">
                Solo aceptamos las siguientes extensiones de archivo
                (.xls,.xlsx,.xlsm,.xlsb,.csv)
              </small>
            )}
          </div>
          {error && (
            <p className="bg-danger p-1 text-white mt-3 rounded text-center">
              {error}
            </p>
          )}
          {success && (
            <p className="bg-success p-1 text-white mt-3 rounded text-center">
              Lecturas modificadas con éxito
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={buttonDisabled}
            color="success"
            onClick={modificarLecturas}
          >
            Modificar Lecturas
          </Button>
          <Button color="danger" onClick={cerrarModal}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModifyFileModal;
